import script from "./VerificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationModal.vue?vue&type=script&setup=true&lang=js"

import "./VerificationModal.vue?vue&type=style&index=0&id=59d7deb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d7deb9"]])

export default __exports__